module.exports = __webpack_public_path__ + "static/clerkie-logo-white-bc35b467de9da2a6e9ab4dfe5fc98170.png";